<details class="ui-disclosure-panel" [open]="open()">
  <summary class="ui-disclosure-panel__summary">
    <span>{{ title() }}</span>
    @if (hint()) {
      <span class="ui-disclosure-panel__hint">{{ hint() }}</span>
    }
  </summary>

  <section class="ui-disclosure-panel__content">
    <ng-content />
  </section>
</details>
